const SubfamilyValidityTresholdIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2141_25701)" />
      <path
        d="M45.3059 21.9047H42.5002V20.0701C42.5002 19.045 41.6369 18.1816 40.6117 18.1816C39.5865 18.1816 38.7232 19.045 38.7232 20.0701V21.9586H31.2772V20.0701C31.2772 19.045 30.4139 18.1816 29.3887 18.1816C28.3635 18.1816 27.5002 19.045 27.5002 20.0701V21.9586H24.6944C23.1297 21.9047 21.8887 23.1996 21.8887 24.7644V27.5701H48.1117V24.7644C48.1117 23.1996 46.8707 21.9047 45.3059 21.9047Z"
        fill="white"
      />
      <path
        d="M21.8887 46.376C21.8887 47.9408 23.1297 49.1818 24.6944 49.1818H45.3059C46.8707 49.1818 48.1117 47.9408 48.1117 46.376V30.4048H21.8887V46.376ZM40.6656 34.7933C41.9067 34.7933 42.9858 35.8185 42.9858 37.1134C42.9858 38.3544 41.9606 39.4336 40.6656 39.4336C39.4246 39.4336 38.3455 38.4084 38.3455 37.1134C38.3995 35.8185 39.4246 34.7933 40.6656 34.7933Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2141_25701"
          x1="34.5455"
          y1="2.70945e-07"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DAB811" />
          <stop offset="1" stop-color="#BB9C00" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SubfamilyValidityTresholdIconSubcategory
